import React from "react";

export default function About() {
  return (
    <div
      style={{
        fontFamily:
          '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
        backgroundColor: "#fafafa",
        minHeight: "100vh",
      }}
    >
      {/* Header */}
      <header
        style={{
          backgroundColor: "#fff",
          borderBottom: "1px solid #e5e5e5",
          padding: "1rem 2rem",
          position: "sticky",
          top: 0,
          zIndex: 1000,
        }}
      >
        <nav
          style={{
            maxWidth: "1200px",
            margin: "0 auto",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <a
            href="/"
            style={{
              fontSize: "24px",
              fontWeight: "600",
              color: "#1a1a1a",
              letterSpacing: "-0.5px",
              textDecoration: "none",
            }}
          >
            Collavo
          </a>
          <a
            href="/"
            style={{
              backgroundColor: "transparent",
              color: "#1a1a1a",
              padding: "10px 24px",
              fontSize: "15px",
              fontWeight: "500",
              border: "1px solid #e5e5e5",
              borderRadius: "8px",
              cursor: "pointer",
              transition: "all 0.2s ease",
              textDecoration: "none",
              display: "inline-block",
            }}
          >
            Back to Home
          </a>
        </nav>
      </header>

      {/* Content */}
      <main
        style={{
          maxWidth: "800px",
          margin: "0 auto",
          padding: "4rem 2rem",
        }}
      >
        <h1
          style={{
            fontSize: "48px",
            fontWeight: "600",
            color: "#1a1a1a",
            marginBottom: "1.5rem",
            letterSpacing: "-1px",
          }}
        >
          About Collavo
        </h1>

        <p
          style={{
            fontSize: "20px",
            color: "#525252",
            lineHeight: "1.6",
            marginBottom: "3rem",
          }}
        >
          Connecting people who want to help, with the wider church.
        </p>

        <section style={{ marginBottom: "3rem" }}>
          <h2
            style={{
              fontSize: "28px",
              fontWeight: "600",
              color: "#1a1a1a",
              marginBottom: "1rem",
            }}
          >
            Our Mission
          </h2>
          <p
            style={{
              fontSize: "16px",
              color: "#525252",
              lineHeight: "1.7",
              marginBottom: "1rem",
            }}
          >
            Collavo is on a mission to make helping churches easier. 
          </p>
          <p
            style={{
              fontSize: "16px",
              color: "#525252",
              lineHeight: "1.7",
            }}
          >
            The platform can be used to invite and/or receive invitations to serve local churches in different capacities and in an ad-hoc and relaxed manner. This makes it possible to for the right gifts to serve where they are needed at the right time.
          </p>
        </section>

        <section style={{ marginBottom: "3rem" }}>
          <h2
            style={{
              fontSize: "28px",
              fontWeight: "600",
              color: "#1a1a1a",
              marginBottom: "1rem",
            }}
          >
            How It Started
          </h2>
          <p
            style={{
              fontSize: "16px",
              color: "#525252",
              lineHeight: "1.7",
              marginBottom: "1rem",
            }}
          >
            The body of Christ should opperate just like a unified body. Making helping each other out seem simple and natural - like osmosis, just like in our bodies. 
      
          </p>
          <p
            style={{
              fontSize: "16px",
              color: "#525252",
              lineHeight: "1.7",
            }}
          >Collavo can be compared to a road or a highway - is the online infrastructure to know who can help and how - and have the abiblity to reach and connect easily.
          </p>
        </section>

        <section style={{ marginBottom: "3rem" }}>
          <h2
            style={{
              fontSize: "28px",
              fontWeight: "600",
              color: "#1a1a1a",
              marginBottom: "1rem",
            }}
          >
            Our Values
          </h2>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "1.5rem",
            }}
          >
            {[
              {
                title: "Agency",
                description:
                  "We prioritize users choice to deside how and when they want to help.",
              },

       {
                title: "Transparency",
                description:
                  "We're committed to communicating clearly and enabling the same between users.",
              },
              {
                title: "Simplicity",
                description:
                  "We keep things straightforward. No unnecessary features, no complex systems—just the tools you need to connect and serve.",
              },
              // {
              //   title: "Integrity",
              //   description:
              //     "We're committed to creating a safe, trustworthy platform. We encourage proper safeguarding, clear communication, and mutual respect.",
              // },
            ].map((value, index) => (
              <div
                key={index}
                style={{
                  backgroundColor: "#fff",
                  padding: "1.5rem",
                  borderRadius: "8px",
                  border: "1px solid #e5e5e5",
                }}
              >
                <h3
                  style={{
                    fontSize: "18px",
                    fontWeight: "600",
                    color: "#1a1a1a",
                    marginBottom: "0.5rem",
                  }}
                >
                  {value.title}
                </h3>
                <p
                  style={{
                    fontSize: "15px",
                    color: "#525252",
                    lineHeight: "1.6",
                    margin: 0,
                  }}
                >
                  {value.description}
                </p>
              </div>
            ))}
          </div>
        </section>

        <section style={{ marginBottom: "3rem" }}>
          <h2
            style={{
              fontSize: "28px",
              fontWeight: "600",
              color: "#1a1a1a",
              marginBottom: "1rem",
            }}
          >
            For Service Providers
          </h2>
          <p
            style={{
              fontSize: "16px",
              color: "#525252",
              lineHeight: "1.7",
              marginBottom: "1rem",
            }}
          >
            If you want to serve the wider church, Collavo gives
            you a simple way to let churches know you're available. Create you profile and choose how you would like to serve - when invitations come through you can choose to accept or turn them down. 
            
         It's your ministry - you
            stay in control of your availability.
          </p>
   
        </section>

        <section style={{ marginBottom: "3rem" }}>
          <h2
            style={{
              fontSize: "28px",
              fontWeight: "600",
              color: "#1a1a1a",
              marginBottom: "1rem",
            }}
          >
            For Churches
          </h2>
          <p
            style={{
              fontSize: "16px",
              color: "#525252",
              lineHeight: "1.7",
              marginBottom: "1rem",
            }}
          >
            Whether you need a guest speaker for Sunday morning, a musician for
            a special event, or an ad-hoc youth worker, Collavo helps you
            find the right person. Browse profiles, see their experience and
            expertise, check their availability, and reach out directly.
          </p>
          <p
            style={{
              fontSize: "16px",
              color: "#525252",
              lineHeight: "1.7",
            }}
          >
            No complicated processes. Just
             connections between churches and gifted people who
            want to serve.
          </p>
        </section>

        <section style={{ marginBottom: "3rem" }}>
          <h2
            style={{
              fontSize: "28px",
              fontWeight: "600",
              color: "#1a1a1a",
              marginBottom: "1rem",
            }}
          >
            What's Next
          </h2>
          <p
            style={{
              fontSize: "16px",
              color: "#525252",
              lineHeight: "1.7",
              marginBottom: "1rem",
            }}
          >
            We're currently in our launch phase, focusing on building a strong
            community of service providers. As we grow, we'll be
            adding features based on real feedback from real users—not what we
            think you need, but what you actually tell us would be helpful.
          </p>
          <p
            style={{
              fontSize: "16px",
              color: "#525252",
              lineHeight: "1.7",
            }}
          >
            We're committed to keeping Collavo simple, useful, and
            ministry-focused. If you have suggestions or feedback, we'd love to
            hear from you.
          </p>
        </section>

        <section
          style={{
            backgroundColor: "#fff",
            padding: "2rem",
            borderRadius: "12px",
            border: "1px solid #e5e5e5",
            textAlign: "center",
          }}
        >
          <h2
            style={{
              fontSize: "24px",
              fontWeight: "600",
              color: "#1a1a1a",
              marginBottom: "1rem",
            }}
          >
            Get In Touch
          </h2>
          <p
            style={{
              fontSize: "16px",
              color: "#525252",
              lineHeight: "1.7",
              marginBottom: "1.5rem",
            }}
          >
            Have questions, feedback, or just want to say hello?
          </p>
          <a
            href="/contact"
            style={{
              display: "inline-block",
              backgroundColor: "#000",
              color: "#fff",
              padding: "12px 32px",
              fontSize: "15px",
              fontWeight: "500",
              border: "none",
              borderRadius: "8px",
              cursor: "pointer",
              transition: "all 0.2s ease",
              textDecoration: "none",
            }}
          >
            Contact Us
          </a>
        </section>
      </main>

      {/* Footer */}
      <footer
        style={{
          borderTop: "1px solid #e5e5e5",
          backgroundColor: "#fff",
          padding: "2rem",
          marginTop: "4rem",
        }}
      >
        <div
          style={{
            maxWidth: "800px",
            margin: "0 auto",
            textAlign: "center",
          }}
        >
          <p
            style={{
              fontSize: "14px",
              color: "#737373",
              marginBottom: "1rem",
            }}
          >
            <a
              href="/privacy"
              style={{
                color: "#737373",
                textDecoration: "none",
                marginRight: "1.5rem",
              }}
            >
              Privacy Policy
            </a>
            <a
              href="/terms"
              style={{
                color: "#737373",
                textDecoration: "none",
                marginRight: "1.5rem",
              }}
            >
              Terms of Service
            </a>
            <a
              href="/contact"
              style={{ color: "#737373", textDecoration: "none" }}
            >
              Contact
            </a>
          </p>
          <p style={{ fontSize: "14px", color: "#737373" }}>
            © 2025 Collavo. All rights reserved.
          </p>
        </div>
      </footer>
    </div>
  );
}
